export enum StatusRequest {
    proceso = 1,
    rechazado = 2,
    aceptado = 3,
    error = 4,
    error_sap = 5
}
